import Joi from '@hapi/joi'

export const OperationentityCollectionCatagoryMappingSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    productID: Joi.number().required().label("Product").messages({
        "any.invalid": `Product cannot have invalid characters`,
        "any.required": `Product required`
    })
}

export const OperationentityCollectionCatagoryMappingEditSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    productID: Joi.number().invalid(0).required().label("Product").messages({
        "any.invalid": `Product cannot have invalid characters`,
        "any.required": `Product required`
    }),
    collectionCategoryMasterID: Joi.number().invalid(0).required().label("Collectioncatagory").messages({
        "string.empty": `Collectioncatagory required`,
        "string.pattern.base": `Please enter valid Collectioncatagory`,
    }),
    isActive: Joi.boolean().label("Active"),
}